// extracted by mini-css-extract-plugin
export default {"header":"styles_header__DDatV","logo":"styles_logo__POMY7","body":"styles_body__W+8s1","button":"styles_button__74+TU","books":"styles_books__LynT0","book":"styles_book__+QJG3"};